// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";

function indicatorToJs(param) {
  return param + 0 | 0;
}

function indicatorFromJs(param) {
  if (param <= 8 && 0 <= param) {
    return param - 0 | 0;
  }
  
}

function getIndicatorColor(banner) {
  switch (banner) {
    case /* Won */0 :
        return Css.hex(SterlingTokens$LiveRoom.Colors.alertGreen60_nohashtag);
    case /* Lost */1 :
        return Css.hex(SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag);
    case /* Outbid */2 :
        return Css.hex(SterlingTokens$LiveRoom.Colors.alertOrange60_nohashtag);
    case /* Premium */3 :
        return Css.hex(SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag);
    case /* NoReserve */5 :
        return Css.hex(SterlingTokens$LiveRoom.Colors.alertTurq60_nohashtag);
    case /* Parcel */4 :
    case /* FirstInParcel */6 :
    case /* LastInParcel */7 :
        return Css.hex("DCA3B8");
    case /* Default */8 :
        return StyleConstants$LiveRoom.borderColor;
    
  }
}

function getFlag(userBid, isPremium, isNoReserve, firstInParcel, lastInParcel) {
  if (userBid !== undefined) {
    var match = userBid.bidState;
    if (match === "BidAheadOfYou" || match === "Outbid") {
      return [
              /* Outbid */2,
              /* Large */1
            ];
    }
    if (match === "Won") {
      return [
              /* Won */0,
              /* Large */1
            ];
    }
    if (match === "Lost") {
      return [
              /* Lost */1,
              /* Large */1
            ];
    }
    
  }
  if (isPremium) {
    return [
            /* Premium */3,
            /* Small */0
          ];
  } else if (isNoReserve) {
    return [
            /* NoReserve */5,
            /* Small */0
          ];
  } else if (firstInParcel) {
    return [
            /* FirstInParcel */6,
            /* Small */0
          ];
  } else if (lastInParcel) {
    return [
            /* LastInParcel */7,
            /* Small */0
          ];
  } else {
    return ;
  }
}

function getBanner(isPremium, isParcel, isNoReserve) {
  if (isPremium) {
    return /* Premium */3;
  } else if (isParcel) {
    return /* Parcel */4;
  } else if (isNoReserve) {
    return /* NoReserve */5;
  } else {
    return /* Default */8;
  }
}

function LotCardIndicator$Flag(props) {
  var flag = props.flag;
  var dimensions;
  switch (props.size) {
    case /* Small */0 :
        dimensions = 8;
        break;
    case /* Large */1 :
        dimensions = 16;
        break;
    case /* ExtraLarge */2 :
        dimensions = 24;
        break;
    
  }
  var isBottomFlag = flag === /* LastInParcel */7;
  return React.createElement(PropSpread$LiveRoom.make, {
              aria: {
                hd: {
                  TAG: /* Hidden */2,
                  _0: true
                },
                tl: /* [] */0
              },
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "LotCardFlag-" + String(flag + 0 | 0) + ""
                },
                tl: /* [] */0
              },
              children: React.createElement("div", {
                    className: Curry._1(Css.merge, {
                          hd: Curry._1(Css.style, {
                                hd: Css.position("absolute"),
                                tl: {
                                  hd: Css.right(Css.px(-2)),
                                  tl: {
                                    hd: Css.width("zero"),
                                    tl: {
                                      hd: Css.height("zero"),
                                      tl: {
                                        hd: Css.borderStyle("solid"),
                                        tl: {
                                          hd: Css.borderTop("zero", "solid", "transparent"),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }),
                          tl: {
                            hd: isBottomFlag ? Curry._1(Css.style, {
                                    hd: Css.bottom(Css.px(0)),
                                    tl: {
                                      hd: Css.borderRight("zero", "none", "transparent"),
                                      tl: {
                                        hd: Css.borderLeft(Css.px(dimensions), "solid", "transparent"),
                                        tl: {
                                          hd: Css.borderBottom(Css.px(dimensions), "solid", getIndicatorColor(flag)),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }) : Curry._1(Css.style, {
                                    hd: Css.top(Css.px(0)),
                                    tl: {
                                      hd: Css.borderRight(Css.px(dimensions), "solid", getIndicatorColor(flag)),
                                      tl: {
                                        hd: Css.borderLeft("zero", "solid", "transparent"),
                                        tl: {
                                          hd: Css.borderBottom(Css.px(dimensions), "solid", "transparent"),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }),
                            tl: /* [] */0
                          }
                        })
                  })
            });
}

var Flag = {
  make: LotCardIndicator$Flag
};

export {
  indicatorToJs ,
  indicatorFromJs ,
  getIndicatorColor ,
  getFlag ,
  getBanner ,
  Flag ,
}
/* Css Not a pure module */
